package views.componentes

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import bt1Hei
import fontSmall
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

@Composable
fun ffButton(value: MutableState<String>, _onclick: (Boolean) -> Unit, _width: Int) {

    //return Div({ style { width(_width.percent); fontSize(small); paddingLeft(10.px) } }) {
    Div({ classes("input-group-append"); style { width(_width.percent) } }) {

        Button(attrs = {
            classes("btn", "dlg-mobbt100")
            //classes("btn")
            //style { fontSize(fontSmall); height(bt1Hei); width(_width.percent); top(40.percent) }
            style { fontSize(fontSmall); height(bt1Hei); top(30.percent); left(10.px) }
            onKeyDown { _ -> _onclick.invoke(true) }
            onClick { _ -> _onclick.invoke(true) }
            if (!value.enabled()) {
                disabled()
            }
        }
        ) {
            Text(value.text())
        }
    }
}

